module.exports = __webpack_public_path__ + "img/jiagou_banner.06b91450.png";